import React, { useEffect } from "react";
import { Box, Button, Typography, Fade } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export const DummySubmitSuccessPopup = ({
  onClose,
  autoClose = true,     // whether to auto-close
  autoCloseDelay = 5000, // ms
}) => {
  useEffect(() => {
    if (!autoClose) return;

    const timer = setTimeout(() => {
      onClose?.();
    }, autoCloseDelay);

    return () => clearTimeout(timer);
  }, [autoClose, autoCloseDelay, onClose]);

  return (
    <Fade in timeout={600}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          bgcolor: "rgba(0, 0, 0, 0.65)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1400,
          p: 2,
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            borderRadius: 3,
            p: { xs: 3, sm: 5 },
            maxWidth: 460,
            width: "100%",
            textAlign: "center",
            boxShadow: 24,
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Optional subtle background gradient */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(135deg, rgba(249,115,22,0.08), rgba(239,68,68,0.08))",
              zIndex: 0,
            }}
          />

          <Box sx={{ position: "relative", zIndex: 1 }}>
            <CheckCircleOutlineIcon
              color="success"
              sx={{
                fontSize: 80,
                mb: 3,
                animation: "pop 0.6s ease-out",
              }}
            />

            <Typography
              variant="h5"
              fontWeight={700}
              gutterBottom
              color="text.primary"
            >
              Successfully Submitted!
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 4, maxWidth: 360, mx: "auto" }}
            >
              Your responses have been saved and submitted successfully.
            </Typography>

            <Button
                className="tour-close-btn"
              variant="contained"
              size="large"
              onClick={onClose}
              sx={{
                minWidth: 160,
                py: 1.5,
                px: 5,
                background: "linear-gradient(90deg, #f97316, #ef4444)",
                fontWeight: 600,
                "&:hover": {
                  background: "linear-gradient(90deg, #ea580c, #dc2626)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 6px 12px rgba(239,68,68,0.25)",
                },
                transition: "all 0.2s ease",
              }}
            >
              Close
            </Button>
          </Box>

          {/* Inline keyframe for pop animation */}
          <style>
            {`
              @keyframes pop {
                0%   { transform: scale(0.6); opacity: 0; }
                50%  { transform: scale(1.15); }
                100% { transform: scale(1); opacity: 1; }
              }
            `}
          </style>
        </Box>
      </Box>
    </Fade>
  );
};